export const DeliveryOffsetRule = (data: IDeliveryOffsetRule): IDeliveryOffsetRuleModel => {
	const { offset_days, ...rest } = data

	return {
		...rest,
		offsetDays: offset_days,
	}
}

export const DeliveryOffsetRuleToJson = (data: IDeliveryOffsetRuleModel): IDeliveryOffsetRule => {
	const { offsetDays, ...rest } = data

	return {
		...rest,
		offset_days: offsetDays,
	}
}
